import axios, { AxiosRequestConfig } from 'axios';
import { HOST_API } from 'src/config-global';

const axiosPublic = axios.create({
  baseURL: HOST_API,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

axiosPublic.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Đã có lỗi xảy ra !')
);

export default axiosPublic;

export const fetcherPublic = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosPublic.get(url, { ...config });

  return res.data;
};
